import blog1 from "../../assets/images/meeting-with-client-for-gathering-requirements.webp";
import blog2 from "../../assets/images/brainstorming-the-best-software-solutions.webp";
import blog3 from "../../assets/images/website-designers-discussing-low-fidelity-mockups.webp";
import blog4 from "../../assets/images/coding-on-a-computer.webp";
import blog5 from "../../assets/images/software-testing.webp";

export const process = [
  {
    title: "Discovery & Requirements Gathering",
    image: blog1,
    description:
      "We listen first and listen well, making sure you’re heard and understood before being presented with a solution for your vision and goals. ",
  },
  {
    title: "Ideation  & Planning",
    image: blog2,
    description:
      "Our experts brainstorm the smartest technical solution to your requirements and present the actionable software architecture and workflows.",
  },
  {
    title: "Design & prototyping",
    image: blog3,
    description:
      "Aesthetically pleasing mockups for the software’s user-interface are presented which are further elaborated by interactive prototyping to demonstrate the software’s functionality and user-experience. ",
  },
  {
    title: "Development & testing",
    image: blog4,
    description:
      "Our in-house team of specialists executes the full-stack coding of software, while ensuring top-notch quality assurance protocols at each stage.  ",
  },
  {
    title: "Deployement & Maintenance",
    image: blog5,
    description:
      "From hassle-free launch to consistent support and upgrades, we’ve got you covered.  ",
  },
];
export const faqData = [
  {
    id: "01",
    question: "What is the potential of digital marketing?",
    answer:
      "Digital marketing represents the present and future of business growth. With consumer attention and advertising dynamics shifting decisively online, companies are focusing on establishing a strong digital presence to remain visible to today’s vast and ever-expanding internet community. Businesses mastering visibility in search results and recommendations are dominating their markets. ",
  },
  {
    id: "02",
    question:
      "How do I know what digital marketing strategy would work for my business? ",
    answer:
      " At Apptalyst, we professionally research your business and industry’s dynamics in the digital landscape and only present a solution which is actually beneficial for you. Driven by data-analytics, we have a knack for practical solutions. ",
  },

  {
    id: "03",
    question: "What is paid marketing?",
    answer:
      "Performance marketing, also referred to as paid marketing, is an online advertising strategy focused on driving targeted traffic and sales conversions through various advertisement campaigns. ",
  },

  {
    id: "04",
    question: "What do I need for getting started? ",
    answer:
      "To begin, you’ll need established brand identity and online presence foundations before posting content or launching marketing campaigns. The good news is, Apptalyst is a one-stop shop and can expertly assist you build these essentials first. ",
  },

  {
    id: "05",
    question: "How can I predict if my marketing venture would be profitable? ",
    answer:
      " Profitability in marketing relies on data-driven decisions and calculated investments based on your niche’s potential across various digital channels. At Apptalyst, we do all the research and brainstorming so you can invest with confidence. ",
  },
];
